export interface SnapshotVersion { generation?: string; revision?: number; privateRevision?: number; }
export function snapshotVersion(current: SnapshotVersion, incoming: SnapshotVersion): SnapshotVersion {
  const base = incoming.generation && incoming.generation !== current.generation ? {} : current;
  return { generation: incoming.generation ?? base.generation,
    revision: incoming.revision ?? base.revision,
    privateRevision: incoming.privateRevision ?? base.privateRevision };
}
export function canApplySnapshot(current: SnapshotVersion, incoming: SnapshotVersion) {
  if (incoming.generation && incoming.generation !== current.generation) return true;
  if (incoming.revision !== undefined && current.revision !== undefined && incoming.revision < current.revision) return false;
  if (incoming.revision === current.revision && incoming.privateRevision !== undefined && current.privateRevision !== undefined
    && incoming.privateRevision < current.privateRevision) return false;
  return true;
}
